import { action, observable, set } from "mobx";

/**
 * 사업지정 Model
 */
export default class BusinessManagerSelected {
  @observable private bizCd: string ="";
  @observable private bizNm: string = "";
  @observable private bizShortNm: string = "";
  @observable private userid: string = "";
  @observable private baseBizYn!: boolean;
  @observable private selectYn!: boolean;

  public constructor(data?) {
    if (data == null) {
      return;
    }

    set(this, data);
  }
  public getBizCd(): string {
    return this.bizCd;
  }
  @action
  public setBizCd(bizCd: string): void {
    this.bizCd = bizCd;
  }

  public getBizNm(): string {
    return this.bizNm;
  }
  @action
  public setBizNm(bizNm: string): void {
    this.bizNm = bizNm;
  }

  public getBizShortNm(): string {
    return this.bizShortNm;
  }
  @action
  public setBizShortNm(bizShortNm: string): void {
    this.bizShortNm = bizShortNm;
  }

  public getUserid(): string {
    return this.userid;
  }
  @action
  public setUserid(userid: string): void {
    this.userid = userid;
  }

  public isBaseBizYn(): boolean {
    return this.baseBizYn;
  }
  @action
  public setBaseBizYn(baseBizYn: boolean): void {
    this.baseBizYn = baseBizYn;
  }
  public isSelectYn(): boolean {
    return this.selectYn;
  }
  @action
  public setSelectYn(selectYn: boolean): void {
    this.selectYn = selectYn;
  }
}
